module.exports = __webpack_public_path__ + "static/media/calendar_month.092b50c8.svg";